export * from './component/annotation-index/annotation-index.component';

export * from './resolve/annotation.resolve';

export * from './annotation.routing';
